import React, { useState, useContext } from "react";
import { Link, useNavigate } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";

const ForgotPassword = () => {
  const { forgotPassword } = useContext(AuthContext); // Access forgotPassword from context
  const [username, setUsername] = useState("");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const navigate = useNavigate();

  const handleForgotPassword = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage(""); // Clear previous messages
    try {
      await forgotPassword(username); // Call forgotPassword function
      localStorage.setItem("username", username); // Save username in localStorage
      navigate("/password-change"); // Navigate to PasswordChange route
    } catch (err) {
      setMessage(
        "Failed to send instructions. Please check your username and try again."
      ); // Error message
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-full flex-1 flex-col justify-center px-6 py-12 lg:px-8">
      <div className="sm:mx-auto sm:w-full sm:max-w-sm">
        <img
          alt="Your Company"
          src={`${process.env.PUBLIC_URL}/assets/hive.png`}
          className="mx-auto h-20 w-auto"
        />
        <h2 className="mt-10 text-center text-2xl font-bold tracking-tight text-[#414141]">
          Forgot your password?
        </h2>
        <p className="mt-2 text-center text-sm text-gray-500">
          Enter your username and we’ll send you instructions to reset your password.
        </p>
      </div>

      <div className="mt-10 sm:mx-auto sm:w-full sm:max-w-sm">
        <form onSubmit={handleForgotPassword} className="space-y-6">
          <div>
            <label
              htmlFor="username"
              className="block text-sm font-medium text-[#414141]"
            >
              Username
            </label>
            <div className="mt-2">
              <input
                id="username"
                name="username"
                type="text"
                required
                value={username}
                onChange={(e) => setUsername(e.target.value)} // Update state
                className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-[#414141] outline outline-1 -outline-offset-1 outline-[#f7b22d] placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-[#f7b22d] sm:text-sm"
              />
            </div>
          </div>

          <div>
            <button
              type="submit"
              className="flex w-full justify-center rounded-md bg-[#f7b22d] px-3 py-1.5 text-sm font-semibold text-white shadow-sm hover:bg-[#414141] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#f7b22d]"
              disabled={loading}
            >
              {loading ? "Sending..." : "Send Instructions"}
            </button>
          </div>
        </form>

        {message && (
          <div
            className={`mt-4 text-center text-sm ${
              message.includes("Failed") ? "text-red-500" : "text-green-500"
            }`}
          >
            {message}
          </div>
        )}

        <p className="mt-10 text-center text-sm text-gray-500">
          Remembered your password?{" "}
          <Link
            to="/login"
            className="font-semibold text-[#f7b22d] hover:text-[#414141]"
          >
            Sign in
          </Link>
        </p>
      </div>
    </div>
  );
};

export default ForgotPassword;
